var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import Vue from 'vue';
import Component from 'vue-class-component';
import { Dependencies } from '~/core/decorator';
import { Action } from 'vuex-class';
import { Prop, Watch } from 'vue-property-decorator';
import AreaSelection from '~/components/common/area-selection.vue';
import { CityService } from '~/utils/city.service';
import { OutsourceCommissionedService } from '~/services/domain-service/outsource-commissioned-manage.service';
var CommissionedDialog = /** @class */ (function (_super) {
    __extends(CommissionedDialog, _super);
    function CommissionedDialog() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.form = {
            name: '',
            proinviceCode: '',
            cityCode: '',
            companyType: '',
            status: '',
            address: '',
            organizationType: '',
            linkMan: '',
            linkPhone: '',
            email: '',
            collectionAddress: '',
            remark: '',
            areaId: '',
            deptName: '',
            id: '',
        };
        _this.clearSelectedCitysList = false;
        _this.dialog = {
            area: false,
        };
        _this.areaIds = [];
        _this.proinviceList = []; // 省
        _this.cityList = []; //市
        _this.areaCodeIds = ''; //催收区域id
        _this.selectedCitysList = [];
        //验证
        _this.rules = {
            name: [{ required: true, message: '请填写受托方', trigger: 'blur' }],
            organizationType: [{ required: true, message: '请选择机构类型', trigger: 'blur' }],
            status: [{ required: true, message: '请选择状态', trigger: 'blur' }],
            // areaIds: [{ required: true, message: '请选择地区', trigger: 'blur' }],
            address: [{ required: true, message: '请填写具体地址', trigger: 'blur' }],
            linkPhone: [{ required: true, message: '请填写联系人手机号码', trigger: 'blur' }],
            linkMan: [{ required: true, message: '请填写联系人', trigger: 'blur' }],
        };
        return _this;
    }
    CommissionedDialog.prototype.mounted = function () {
        this.formData();
    };
    CommissionedDialog.prototype.onCaseRowChange = function () {
        this.formData();
    };
    Object.defineProperty(CommissionedDialog.prototype, "selectedCitys", {
        get: function () {
            return this.selectedCitysList.map(function (x) { return x.value; });
        },
        enumerable: false,
        configurable: true
    });
    //数据回显
    CommissionedDialog.prototype.formData = function () {
        var _this = this;
        this.initProperty();
        this.getProvinces();
        //   重置form表单xr
        var addForm = this.$refs['add-form'];
        addForm.resetFields();
        this.form = this.caseRow;
        this.selectedCitysList = [];
        var arr = this.$city.getCityParent(Number(this.form.areaId));
        this.areaIds = arr ? arr.concat([Number(this.form.areaId)]) : [];
        //需要去掉,
        if (this.form.areaCodeIds) {
            var temp = this.form.areaCodeIds.split(',').filter(function (item) {
                return item;
            });
            var Ids = temp.map(function (val) { return Number(val); });
            this.selectedCitysList = Ids.map(function (val) {
                return {
                    value: val,
                    label: _this.$city.getCityNameById(val),
                };
            });
        }
    };
    //获取省数据
    CommissionedDialog.prototype.getProvinces = function () {
        this.proinviceList = CityService.getCityData({ level: 1 });
    };
    //获取市
    CommissionedDialog.prototype.getCitys = function (provinceId) {
        this.cityList = this.$city.getCityData({ level: 1, id: provinceId }); // 城市列表
    };
    CommissionedDialog.prototype.selectedCitysClose = function () {
        this.selectedCitysList = this.$refs
            .area.getCheckedCitys();
    };
    CommissionedDialog.prototype.refresh = function (dept) { };
    /**
     * 确认
     */
    CommissionedDialog.prototype.commit = function () {
        var _this = this;
        var addForm = this.$refs['add-form'];
        this.areaCodeIds = this.selectedCitysList.map(function (v) { return v.value; }).join();
        var _a = this.areaIds, prinPrid = _a[0], prinCityid = _a[1], prinCtyid = _a[2];
        this.form.areaId = prinCtyid || prinCityid || prinPrid;
        var param = {
            areaCodeIds: this.areaCodeIds,
            areaId: this.form.areaId,
            deptId: this.form.companyType,
            outSourceType: this.form.organizationType,
            outsAddress: this.form.address,
            outsContacts: this.form.linkMan,
            outsName: this.form.name,
            outsPhone: this.form.linkPhone,
            outsRemark: this.form.remark,
            outsourceStatus: this.form.status,
            email: this.form.email,
            id: this.caseRow.id,
        };
        addForm.validate(function (valid) {
            if (!valid)
                return false;
            _this.outsourceCommissionedService.modifyCutsource(param).subscribe(function (data) {
                //   重置form表单xr
                var addForm = _this.$refs['add-form'];
                addForm.resetFields();
                _this.form = {};
                _this.areaCodeIds = '';
                //   关闭dialog
                _this.$emit('close');
                _this.$message.success("保存成功!");
                //   刷新databox
                _this.$emit('refreshData');
                // 刷新store中的委外方
                _this.getAllOutsource();
            });
        });
    };
    /**
     * 取消
     */
    CommissionedDialog.prototype.cancel = function () {
        // //   重置form表单
        var addForm = this.$refs['add-form'];
        addForm.resetFields();
        this.formData();
        // this.areaCodeIds = '';
        // this.caseRow = {};
        // this.initProperty();
        //   关闭dialog
        this.$emit('close');
    };
    /**
     * 初始化参数
     */
    CommissionedDialog.prototype.initProperty = function () {
        this.form = {
            name: '',
            proinviceCode: '',
            cityCode: '',
            companyType: '',
            status: '',
            address: '',
            organizationType: '',
            linkMan: '',
            linkPhone: '',
            email: '',
            collectionAddress: '',
            remark: '',
            selectedCitysList: [],
            areaId: '',
            deptName: '',
            idL: '',
        };
    };
    CommissionedDialog.prototype.closeArea = function () {
        this.dialog.area = false;
    };
    CommissionedDialog.prototype.saveArea = function () {
        this.selectedCitysClose();
        this.dialog.area = false;
    };
    __decorate([
        Dependencies(OutsourceCommissionedService)
    ], CommissionedDialog.prototype, "outsourceCommissionedService", void 0);
    __decorate([
        Action
    ], CommissionedDialog.prototype, "getAllOutsource", void 0);
    __decorate([
        Prop({ required: true }),
        Prop()
    ], CommissionedDialog.prototype, "caseRow", void 0);
    __decorate([
        Watch('caseRow')
    ], CommissionedDialog.prototype, "onCaseRowChange", null);
    CommissionedDialog = __decorate([
        Component({
            components: {
                AreaSelection: AreaSelection,
            },
        })
    ], CommissionedDialog);
    return CommissionedDialog;
}(Vue));
export default CommissionedDialog;
